export function useTableQueryBuilder() {
  const createPaginationQuery = ({ page, pageSize }) => {
    const params = new URLSearchParams();

    if (!isNaN(page)) params.append("pagination[page]", page);
    if (!isNaN(pageSize)) params.append("pagination[pageSize]", pageSize);

    return params.toString();
  }

  const createSearchQuery = ({ field, value }) => {
    const params = new URLSearchParams();

    if (value) params.append(`filters[${field}][$containsi]`, value);

    return params.toString();
  }

  const createQuery = ({ pagination, search }) => {
    let query = ""

    if (pagination) {
      const createdPaginationQuery = createPaginationQuery(pagination)
      query = join(query, createdPaginationQuery)
    }

    if (search) {
      const createdSearchQuery = createSearchQuery(search)
      query = join(query, createdSearchQuery)
    }

    return query
  }

  const join = (query1, query2) => {
    let query = query1 || ""

    if (query2?.length) query += `&${query2}`

    return query
  }

  return {
    createPaginationQuery,
    createSearchQuery,
    createQuery,
    join
  }
}
